import { CalendarOutlineIcon } from './CalendarOutlineIcon';

/**
 * author: Google
 * id 3703C79F-7F34-41D6-A12F-6247144FEB02
 * name calendar-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-outline.svg
 * tags
 * - Date / Time 
 */
export const EventOutlineIcon = CalendarOutlineIcon;
export default EventOutlineIcon